import { render } from "./IndependentBillingListPage.vue?vue&type=template&id=2b42f559&ts=true"
import script from "./IndependentBillingListPage.vue?vue&type=script&lang=ts"
export * from "./IndependentBillingListPage.vue?vue&type=script&lang=ts"

import "./IndependentBillingListPage.vue?vue&type=style&index=0&id=2b42f559&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__